import HttpClient from "@/common/boot/HttpClient"

const listarRegionais = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-regionais', { params: payload }).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const listarRegionaisComPaginacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-regionais/listar/paginado', { params: payload }).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });

  commit('CARREGANDO', false);
}

const listarRegionaisPermitidas = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-regionais/listar/permitidas', { params: payload }).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });

  commit('CARREGANDO', false);
}

const excluirRegionais = async ({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    try {
        await Promise.all(
            payload.map(item => excluir(item))
        );

        await dispatch('listarRegionaisComPaginacao');
    } finally {
        commit('CARREGANDO', false);
    }
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-regionais/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarRegional = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-regionais', payload).then(response => {
    dispatch('listarRegionaisComPaginacao');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarRegional = ({ commit, state }, payload) => {

  commit('CARREGANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_REGIONAL_SELECIONADA', ...item);
    return true;
  }

  commit('CARREGANDO', false);

  return false;
}

const atualizarRegional = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-regionais/${payload.id}`, payload).then(response => {
    dispatch('listarRegionaisComPaginacao');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarRegional = async ({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post(`/ctrl-regionais/${payload}/restaurar/`).then(response => {
        dispatch('listarRegionaisComPaginacao');
        return response;
    }).finally(() => {
        commit('CARREGANDO', false);
    });
}

export {
  listarRegionais,
  listarRegionaisComPaginacao,
  listarRegionaisPermitidas,
  excluirRegionais,
  salvarRegional,
  recuperarRegional,
  atualizarRegional,
  restaurarRegional,
}